const actions = {
  GET_COUNTIES: 'GET_COUNTIES',
  GET_COUNTIES_ENDED: 'GET_COUNTIES_ENDED',
};
export default actions;
